import { render, staticRenderFns } from "./PosterGraphql.vue?vue&type=template&id=7852e630"
import script from "./PosterGraphql.vue?vue&type=script&lang=ts&setup=true"
export * from "./PosterGraphql.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PosterGraphql.vue?vue&type=style&index=0&id=7852e630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports